const types = {
    SHOW_TOLL_FREE_ADD_NUMBERS_MODAL: 'SHOW_TOLL_FREE_ADD_NUMBERS_MODAL',
    SHOW_TOLL_FREE_ADD_NUMBER_MODAL: 'SHOW_TOLL_FREE_ADD_NUMBER_MODAL',
    SHOW_TOLL_FREE_VERIFICATION_MODAL: 'SHOW_TOLL_FREE_VERIFICATION_MODAL',
    SHOW_DATA_FOR_RECOVERED_TOLL_FREE_VERIFICATION_ITEM:
        'SHOW_DATA_FOR_RECOVERED_TOLL_FREE_VERIFICATION_ITEM',

    SHOW_TOLL_FREE_DELETE: 'SHOW_TOLL_FREE_DELETE',

    SHOW_TOLL_FREE_DETAILS: 'SHOW_TOLL_FREE_DETAILS',
};

const state = () => ({
    _showTollFreeAddNumbersModal: false,
    _showTollFreeAddNumbersModalItem: null,

    _showTollFreeAddNumberModal: false,
    _tollFreeAddNumberModalCallback: null,

    _showTollFreeVerificationModal: false,
    _showTollFreeVerificationModalType: null,
    _showTollFreeVerificationModalDisabledNumbersStep: false,
    _showTollFreeVerificationModalPhoneUpdateData: null,
    _showTollFreeVerificationDataForRecoveredItem: null,
    _showTollFreeVerificationItem: null,

    _showTollFreeDeleteModal: false,
    _showTollFreeDeleteItem: null,

    _showTollFreeDetailsModal: false,
    _showTollFreeDetailsModalNumberItem: null,
    _showTollFreeDetailsModalType: null,
    _showTollFreeDetailsModalUseShowUpdateModal: false,
    _showTollFreeDetailsItem: null,
});

const getters = {
    showTollFreeAddNumbersModal: (state) => state._showTollFreeAddNumbersModal,
    showTollFreeAddNumbersModalItem: (state) => state._showTollFreeAddNumbersModalItem,

    showTollFreeAddNumberModal: (state) => state._showTollFreeAddNumberModal,
    tollFreeAddNumberModalCallback: (state) => state._tollFreeAddNumberModalCallback,

    showTollFreeVerificationModal: (state) => state._showTollFreeVerificationModal,
    showTollFreeVerificationModalType: (state) => state._showTollFreeVerificationModalType,
    showTollFreeVerificationModalDisabledNumbersStep: (state) =>
        state._showTollFreeVerificationModalDisabledNumbersStep,
    showTollFreeVerificationModalPhoneUpdateData: (state) =>
        state._showTollFreeVerificationModalPhoneUpdateData,
    showTollFreeVerificationItem: (state) => state._showTollFreeVerificationItem,
    showTollFreeVerificationDataForRecoveredItem: (state) =>
        state._showTollFreeVerificationDataForRecoveredItem,

    showTollFreeDeleteModal: (state) => state._showTollFreeDeleteModal,
    showTollFreeDeleteItem: (state) => state._showTollFreeDeleteItem,

    showTollFreeDetailsModal: (state) => state._showTollFreeDetailsModal,
    showTollFreeDetailsModalNumberItem: (state) => state._showTollFreeDetailsModalNumberItem,
    showTollFreeDetailsModalType: (state) => state._showTollFreeDetailsModalType,
    showTollFreeDetailsModalUseShowUpdateModal: (state) =>
        state._showTollFreeDetailsModalUseShowUpdateModal,
    showTollFreeDetailsItem: (state) => state._showTollFreeDetailsItem,
};

const actions = {
    handleShowTollFreeAddNumbersModal({ commit }, data) {
        commit(types.SHOW_TOLL_FREE_ADD_NUMBERS_MODAL, data);
    },

    handleShowTollFreeAddNumberModal({ commit }, data) {
        commit(types.SHOW_TOLL_FREE_ADD_NUMBER_MODAL, data);
    },

    handleShowTollFreeVerificationModal({ commit }, data) {
        commit(types.SHOW_TOLL_FREE_VERIFICATION_MODAL, data);
    },

    setTollFreeDataForRecoveredVerification({ commit }, item) {
        commit(types.SHOW_DATA_FOR_RECOVERED_TOLL_FREE_VERIFICATION_ITEM, item);
    },

    handleShowTollFreeDeleteModal({ commit }, data) {
        commit(types.SHOW_TOLL_FREE_DELETE, data);
    },

    handleShowTollFreeDetailsModal({ commit }, data) {
        commit(types.SHOW_TOLL_FREE_DETAILS, data);
    },
};

const mutations = {
    [types.SHOW_TOLL_FREE_DETAILS](
        state,
        { status = false, item = null, numberItem = null, type = null, useShowUpdateModal = false }
    ) {
        state._showTollFreeDetailsModalUseShowUpdateModal = useShowUpdateModal;
        state._showTollFreeDetailsModalNumberItem = numberItem;
        state._showTollFreeDetailsItem = item;
        state._showTollFreeDetailsModalType = type;
        state._showTollFreeDetailsModal = status;
    },

    [types.SHOW_TOLL_FREE_DELETE](state, { status, item }) {
        state._showTollFreeDeleteItem = item;
        state._showTollFreeDeleteModal = status;
    },

    [types.SHOW_TOLL_FREE_ADD_NUMBERS_MODAL](state, { status, item }) {
        state._showTollFreeAddNumbersModalItem = item;
        state._showTollFreeAddNumbersModal = status;
    },

    [types.SHOW_TOLL_FREE_ADD_NUMBER_MODAL](state, { status, callback }) {
        state._showTollFreeAddNumberModal = status;
        state._tollFreeAddNumberModalCallback = callback ?? null;
    },

    [types.SHOW_TOLL_FREE_VERIFICATION_MODAL](
        state,
        {
            status = false,
            type = null,
            disabledNumbersStep = false,
            phoneUpdateData = null,
            item = null,
        }
    ) {
        state._showTollFreeVerificationItem = item;
        state._showTollFreeVerificationModalPhoneUpdateData = phoneUpdateData;
        state._showTollFreeVerificationModalDisabledNumbersStep = disabledNumbersStep;
        state._showTollFreeVerificationModalType = type;
        state._showTollFreeVerificationModal = status;
    },

    [types.SHOW_DATA_FOR_RECOVERED_TOLL_FREE_VERIFICATION_ITEM](state, item) {
        state._showTollFreeVerificationDataForRecoveredItem = item;
    },
};

export const TollFreeStore = {
    state,
    getters,
    actions,
    mutations,
};
